import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class FittingOrdererEditComponent extends React.Component {

	constructor(props) {
		super(props);

		this.suitCountDisplay = 'none';
		if (this.props.forInsert) {
			this.suitCountDisplay = '';
		}
	}

	componentDidMount() {
		this.props.findAllFirefighterTypes();
	}

	render() {
		return (
			<div>
				<Row style={{ marginTop: 10 }}>
					<Col xs={2} sm={2} md={2}>
						<Button onClick={this.props.editOrderer} bsStyle="info">
							Submit
					    </Button>
					</Col>
					<Col xs={10} sm={10} md={10}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={12} sm={12} md={12}>
						<label className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderer.get('orderId')}</label>
						<DropDownInput id="firefighterType"
							label="警義消別"
							required="true"
							options={this.props.allFirefighterTypes.map((value, key) => ({ label: value.get('display_name'), value: value.get('firefighter_type') })).toJS()}
							selected={[{ label: this.props.orderer.get('displayName'), value: this.props.orderer.get('firefighterType') }]}
							onChange={(id, value, label) => {
								this.props.setValue(id, value);
								this.props.setValue('displayName', label);
								this.props.setValue('category', label);
							}}
							validation={this.props.ordererValidation.get('firefighterType')}
						/>
						<FieldGroup
							id="category"
							type="text"
							label="群組 (統計報表使用，預設為警義消別)"
							value={this.props.orderer.get('category')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('category')}
						/>
						<FieldGroup
							id="firefighterCorporation"
							type="text"
							label="單位"
							value={this.props.orderer.get('firefighterCorporation')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('firefighterCorporation')}
						/>
						<FieldGroup
							id="firefighterDivision"
							type="text"
							label="大隊"
							value={this.props.orderer.get('firefighterDivision')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('firefighterDivision')}
						/>
						<FieldGroup
							id="firefighterSquadron"
							type="text"
							label="分隊"
							value={this.props.orderer.get('firefighterSquadron')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('firefighterSquadron')}
						/>
						<FieldGroup
							id="firefighterTitle"
							type="text"
							label="職稱"
							value={this.props.orderer.get('firefighterTitle')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('firefighterTitle')}
						/>
						<FieldGroup
							id="firefighterName"
							type="text"
							label="姓名"
							value={this.props.orderer.get('firefighterName')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('firefighterName')}
						/>
						<div style={{ display: this.suitCountDisplay }}>
							<FieldGroup
								id="suitCount"
								type="number"
								label="套數"
								value={this.props.orderer.get('suitCount')}
								placeholder=""
								onChange={(id, value) => {
									this.props.setValue(id, value);
								}}
								validation={this.props.ordererValidation.get('suitCount')}
							/>
						</div>
						<FieldGroup
							id="remark"
							type="text"
							label="備註"
							value={this.props.orderer.get('remark')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.ordererValidation.get('remark')}
							componentClass="textarea"
							rows="3"
						/>
					</Col>
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/FittingOrdererEditComponent.jsx